import styles from '@/pages/WeeklyPlanningPage.module.css';

export interface NotesSectionProps {
  notes: string;
  onChange: (notes: string) => void;
}

export function NotesSection({ notes, onChange }: NotesSectionProps) {
  return (
    <section className={styles.notesSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Planning Notes</h2>
      </div>

      <textarea
        className={styles.notesTextarea}
        value={notes}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Capture your weekly planning thoughts, key deadlines, or anything else that helps you prepare for the week ahead..."
        rows={6}
      />
    </section>
  );
}
